import { progress } from "../shared/progress";

export const accountLinkedPage = document.getElementById('page-account-linked');

export function initAccountLinkedPage() {
    const progressEl = document.getElementById('account-linked-progress');
    const progressSuccessText = 'Account linked succesfully';

    setTimeout(() => {
        progress(progressEl, 3000, 100, progressSuccessText, finalizeAccountLinkedPage);
    }, 1000);
}

const finalizeAccountLinkedPage = () => {
    const accountLinkedCta = document.getElementById('account-linked-cta');
    accountLinkedCta.classList.add('auth-cta--visible');
};
